import * as React from 'react';
import { Switch as BaseSwitch } from '@base-ui/react/switch';
import { cn } from '../../lib/utils';

export type SwitchProps = React.ComponentPropsWithoutRef<typeof BaseSwitch.Root>;

/**
 * On / off switch on the Base UI Switch (`role="switch"`). Use it for settings
 * that apply at once; use `Checkbox` for choices submitted with a form. Name it
 * with `<Label htmlFor={id}>` or `aria-label`.
 */
const Switch = React.forwardRef<HTMLElement, SwitchProps>(({ className, ...props }, ref) => (
  <BaseSwitch.Root
    ref={ref}
    className={cn(
      'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border border-transparent bg-[var(--color-hairline-strong)] p-0.5 ring-offset-background transition-colors',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      'data-[checked]:bg-primary data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50',
      className,
    )}
    {...props}
  >
    <BaseSwitch.Thumb className="pointer-events-none block size-4 rounded-full bg-background shadow-sm transition-transform data-[checked]:translate-x-4 rtl:data-[checked]:-translate-x-4" />
  </BaseSwitch.Root>
));
Switch.displayName = 'Switch';

export { Switch };
